import React from "react";
import "./button.css";
export default function Clam() {
  return (
    <button className="inline-flex items-center justify-center text-xs sm:text-sm lg:text-18 font-semibold font-inter px-32 md:px-7 py-2 border-2 bg-btnbg border-btnbg hover:bg-transparent rounded-full lg:px-8 lg:py-3 uppercase text-center mt-8 button-hero">
      <span>Clam</span>
    </button>
  );
}
